const MS_IN_SECOND = 1000;
const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;

/**
 * Quantos ciclos de atualização podem falhar antes do painel se declarar
 * desatualizado. Três dá margem para uma instabilidade passageira sem esconder
 * uma queda real por muito tempo.
 */
export const STALE_CYCLE_TOLERANCE = 3;

/**
 * Decompõe a idade do dado em unidade e valor, para o rótulo permanente do painel.
 *
 * @param {Number} ageInMs Milissegundos desde a última atualização completa.
 * @returns {Object} `{ unit, value }`, com unit em 'seconds', 'minutes' ou 'hours'.
 */
export function describeAge(ageInMs) {
  const seconds = Math.max(0, Math.floor((ageInMs || 0) / MS_IN_SECOND));

  if (seconds < SECONDS_IN_MINUTE) {
    return { unit: 'seconds', value: seconds };
  }

  const minutes = Math.floor(seconds / SECONDS_IN_MINUTE);
  if (minutes < MINUTES_IN_HOUR) {
    return { unit: 'minutes', value: minutes };
  }

  return { unit: 'hours', value: Math.floor(minutes / MINUTES_IN_HOUR) };
}

/**
 * Decide se o dado exibido é velho o bastante para o painel degradar visualmente.
 *
 * Um painel de vigilância que mostra dado velho como se fosse atual afirma que
 * está tudo bem enquanto está cego.
 *
 * @param {Number} ageInMs Idade do dado exibido.
 * @param {Number} refreshIntervalInSeconds Intervalo configurado de atualização.
 * @returns {Boolean} True quando o painel deve se marcar como desatualizado.
 */
export function isStale(ageInMs, refreshIntervalInSeconds) {
  if (!refreshIntervalInSeconds) {
    return false;
  }

  const toleranceInMs = refreshIntervalInSeconds * STALE_CYCLE_TOLERANCE * MS_IN_SECOND;
  return (ageInMs || 0) > toleranceInMs;
}
